const b64url = (buf) =>
  btoa(
    String.fromCharCode(
      ...new Uint8Array(buf instanceof ArrayBuffer ? new Uint8Array(buf) : buf)
    )
  )
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

const rand = (len = 64) => {
  const arr = new Uint8Array(len);
  crypto.getRandomValues(arr);
  return b64url(arr);
};

const sha256 = async (text) => {
  const enc = new TextEncoder().encode(text);
  const hash = await crypto.subtle.digest("SHA-256", enc);
  return b64url(hash);
};

export async function createPkce() {
  const code_verifier = rand(64);
  const code_challenge = await sha256(code_verifier);
  const state = rand(24);
  sessionStorage.setItem("pkce_verifier", code_verifier);
  sessionStorage.setItem("oauth_state", state);
  return { code_verifier, code_challenge, state };
}
